// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HW1Zp","content":"styles_content__2u9uh"};